import * as React from "react"
import { SVGProps } from "react"

const Eye = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={16}
    height={16}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 4C4.763 4 3.26 6.515 2.731 7.702a.726.726 0 0 0 0 .596C3.26 9.485 4.763 12 8.001 12c3.236 0 4.74-2.515 5.268-3.703a.726.726 0 0 0 0-.595C12.74 6.515 11.237 4 8 4ZM1.513 7.16C2.093 5.858 3.928 2.666 8 2.666c4.073 0 5.907 3.192 6.487 4.494a2.06 2.06 0 0 1 0 1.68c-.58 1.301-2.414 4.493-6.487 4.493-4.072 0-5.907-3.192-6.487-4.493a2.059 2.059 0 0 1 0-1.68Z"
      fill="#9DA3B7"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 5.333a2.667 2.667 0 1 0 0 5.334 2.667 2.667 0 0 0 0-5.333Zm-.056 1.335L8 6.667a1.333 1.333 0 1 1-1.332 1.277 1 1 0 0 0 1.276-1.276Z"
      fill="#9DA3B7"
    />
  </svg>
)

export default Eye
